import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import { modalTypes } from "constants/types";
import { logout } from "slices/app/actions/app";
import { hideModal } from "slices/app/actions/modals";

export const recordAupAcceptance = createAsyncThunk(
  "aupAcceptance/record",
  async (_, { dispatch }) => {
    await localhost.post("/api/aup-acceptance");
    dispatch(hideModal(modalTypes.AUP_ACCEPTANCE));
  }
);

export const declineAup = () => (dispatch) => {
  dispatch(logout());
};

const aupAcceptanceSlice = createSlice({
  name: "aupAcceptance",
  initialState: { isLoading: false },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(recordAupAcceptance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(recordAupAcceptance.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(recordAupAcceptance.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default aupAcceptanceSlice.reducer;
